import { BookOpen, LogOut, MessageCircle, Plus, Search, User } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { useAuth } from "../../contexts/AuthContext";

export const MobileNav = ({ isOpen, onToggle }) => {
  const { isAuthenticated, logout } = useAuth();

  if (!isOpen) return null;
  return (
    <div className="md:hidden absolute top-full left-3 right-3 rounded bg-white border-b border-gray-200 shadow-lg animate-fade-in">
      <div className="container px-4 py-4 mx-auto flex flex-col space-y-4">
        <Link
          to="browse"
          className="flex items-center py-2 hover:bg-gray-50 px-2 rounded-md"
          onClick={onToggle}
        >
          <Search className="w-5 h-5 mr-3 text-igbanwo-mint" />
          Browse Lisitngs
        </Link>
        <Link
          to="/"
          state={{ scrollTo: "how-it-works" }}
          className="flex items-center py-2 hover:bg-gray-50 px-2 rounded-md"
          onClick={onToggle}
        >
          <Search className="w-5 h-5 mr-3 text-igbanwo-mint" />
          How It Works
        </Link>
        <Link
          to="/resources"
          className="flex items-center py-2 hover:bg-gray-50 px-2 rounded-md"
          onClick={onToggle}
        >
          <BookOpen className="w-5 h-5 mr-3 text-igbanwo-mint" />
          Resources
        </Link>

        {isAuthenticated ? (
          <>
            <Link
              to="/create-listing"
              className="flex items-center py-2 hover:bg-gray-50 px-2 rounded-md"
              onClick={onToggle}
            >
              <Plus className="w-5 h-5 mr-3 text-igbanwo-mint" />
              Create Listing
            </Link>
            <Link
              to="/profile"
              className="flex items-center py-2 hover:bg-gray-50 px-2 rounded-md"
              onClick={onToggle}
            >
              <User className="w-5 h-5 mr-3 text-igbanwo-mint" />
              Profile
            </Link>
            <Link
              to="/messages"
              className="flex items-center py-2 hover:bg-gray-50 px-2 rounded-md"
              onClick={onToggle}
            >
              <MessageCircle className="w-5 h-5 mr-3 text-igbanwo-mint" />
              Messages
            </Link>
            <button
              onClick={logout}
              className="flex items-center py-2 hover:bg-gray-50 px-2 rounded-md text-red-500"
            >
              <LogOut className="w-5 h-5 mr-3" />
              Sign Out
            </button>
          </>
        ) : (
          <div className="pt-2 space-y-3">
            <Link
              to="/auth?mode=login"
              className="block w-full"
              onClick={onToggle}
            >
              <Button
                variant="outline"
                className="w-full border-igbanwo-mint/20"
              >
                Sign In
              </Button>
            </Link>
            <Link
              to="/auth?mode=register"
              className="block w-full"
              onClick={onToggle}
            >
              <Button className="w-full bg-igbanwo-mint hover:bg-igbanwo-mint/90 text-white">
                Join now
              </Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};